import Dropdown from './_dropdown';
import DropdownMenu from './_dropdown_menu';
import RadioCheckboxList from './_radio_checkbox_list';
import FlashMessage from './_flash_message';
import Icon from './_icon';
import ListItemsManage from './_list_items_manage';
import ReactUpdate from 'immutability-helper';
import DigestVisibilityGroups from './_digest_visibility_groups';

import {pluralize, capitalize} from '../modules/text_utils';
import moment from 'moment';

import {Link} from 'react-router-dom';
import {getNextDigestUTCDateTime} from '../modules/digest_utils';

const reviewFrequencyOptions = [
  {value: 'daily', label: 'Daily'},
  {value: 'weekly', label: 'Weekly'},
  {value: 'biweekly', label: 'Bi-Weekly'},
  {value: 'monthly', label: 'Monthly'},
  {value: 'once', label: 'Once'},
  {value: 'never', label: 'Never'}
];

const reviewDayOptions = [
  {value: 'monday', label: 'Monday'},
  {value: 'tuesday', label: 'Tuesday'},
  {value: 'wednesday', label: 'Wednesday'},
  {value: 'thursday', label: 'Thursday'},
  {value: 'friday', label: 'Friday'},
  {value: 'saturday', label: 'Saturday'},
  {value: 'sunday', label: 'Sunday'}
];

const reviewHourOptions = [
  {value: 0, label: '00:00 UTC'},
  {value: 1, label: '01:00 UTC'},
  {value: 2, label: '02:00 UTC'},
  {value: 3, label: '03:00 UTC'},
  {value: 4, label: '04:00 UTC'},
  {value: 5, label: '05:00 UTC'},
  {value: 6, label: '06:00 UTC'},
  {value: 7, label: '07:00 UTC'},
  {value: 8, label: '08:00 UTC'},
  {value: 9, label: '09:00 UTC'},
  {value: 10, label: '10:00 UTC'},
  {value: 11, label: '11:00 UTC'},
  {value: 12, label: '12:00 UTC'},
  {value: 13, label: '13:00 UTC'},
  {value: 14, label: '14:00 UTC'},
  {value: 15, label: '15:00 UTC'},
  {value: 16, label: '16:00 UTC'},
  {value: 17, label: '17:00 UTC'},
  {value: 18, label: '18:00 UTC'},
  {value: 19, label: '19:00 UTC'},
  {value: 20, label: '20:00 UTC'},
  {value: 21, label: '21:00 UTC'},
  {value: 22, label: '22:00 UTC'},
  {value: 23, label: '23:00 UTC'}
];

const defaultFrequency = 'weekly';
const defaultDay = 'thursday';
const defaultHour = 15;
const defaultSendOnceHours = 6;
const digestTypeManageDialogId = 'manage_digest_type_modal';

class CompanySettingsDigest extends React.Component {

  static contextTypes = {
    api: PropTypes.object.isRequired,
    utils: PropTypes.object.isRequired
  };

  state = {
    actionMessageType: CompanySettingsDigest.reviewActionTypes.NONE,
    digestTypes: [],
    sendOnceHours: defaultSendOnceHours,
    visibilityGroups: []
  };

  componentDidMount() {
    this.mounted = true;
    this.loadDigestTypes();
    this.loadVisibilityGroups();
    this.refreshDigestSendTime();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  static reviewActionTypes = {
    NONE: 0,
    UPDATED_ROLE: 1,
    UPDATED_FREQUENCY: 2,
    UPDATED_ITEMS_PER_RIVAL: 3,
    UPDATED_DAY_OFFSET: 4,
    UPDATED_HOUR_OFFSET: 5
  };

  loadVisibilityGroups = () => {
    const {api: {visibilityGroupsGet}} = this.context;

    visibilityGroupsGet({}).then(visibilityGroups => this.setState({
      visibilityGroups: [...visibilityGroups].concat({id: 0, name: 'Full Access Users'})
    }));
  };

  loadDigestTypes = selected => {
    const digestTypeOptions = {
    };

    return new Promise((resolve, reject) => {
      const {api: {digestTypesGet}} = this.context;

      digestTypesGet({digestTypeOptions, code: 'Digest.loadDigestTypes', callback: ({data}) => {
        const defaultDigest = data.find(dt => dt.default);
        const selectedDigestType = selected ? (data.find(dt => dt.id === selected.id) ?? defaultDigest) : (defaultDigest || data[0]);

        this.setState({
          digestTypes: data,
          selectedDigestType
        }, () => {
          if(data) {
            console.log('Digest.loadDigestTypes: loaded digestTypes: %o', data);

            return resolve(data);
          }

          return reject('Digest.loadDigestTypes: failed to load digestTypes');
        });
      }});
    });
  };

  updateDigestType = (digestTypeOptions, callback) => {
    if(!digestTypeOptions || _.isEmpty(digestTypeOptions)) {
      return;
    }

    const {api: {digestTypeUpdate}} = this.context;

    digestTypeUpdate(digestTypeOptions, updatedDigestType => {
      if(!this.mounted) {
        return;
      }

      if(!updatedDigestType) {
        return typeof callback === 'function' && callback(null);
      }

      const {digestTypes} = this.state;
      let {selectedDigestType} = this.state;
      const index = digestTypes.findIndex(dt => dt.id === updatedDigestType.id);

      if(index >= 0) {
        if(selectedDigestType?.id === updatedDigestType.id) {
          selectedDigestType = {...updatedDigestType};
        }

        const updated = {};

        updated[index] = {$set: updatedDigestType};
        this.setState({
          digestTypes: ReactUpdate(digestTypes, updated),
          selectedDigestType
        });
      }

      typeof callback === 'function' && callback(updatedDigestType);
    });
  };

  handleToggleReviewRole = (digestType, role) => {
    const currentReviewRole = digestType?.reviewRole || 'consumer';

    if(!role || (role === currentReviewRole)) {
      return;
    }

    const reviewRole = (role === 'visibilityGroups') ? [] : (role || 'consumer');

    // DEBUG
    console.log('CompanySettingsDigest.handleToggleReviewRole: role: %o', role);

    const digestTypeOptions = {
      id: digestType.id,
      reviewRole
    };

    this.updateDigestType(digestTypeOptions, updated => {
      if(updated) {
        this.setState({
          actionMessageType: CompanySettingsDigest.reviewActionTypes.UPDATED_ROLE
        }, () => {
          // DEBUG
          console.log('CompanySettingsDigest.handleToggleReviewRole: updated role: %o', this.state.actionMessageType);
        });
      }
    });
  };

  sequenceNumber = 0;

  getNextSequenceNumber = () => ++this.sequenceNumber;

  refreshDigestSendTime = (digestTypeId = '') => {
    const {api: {digestGet}} = this.context;

    const sn = this.getNextSequenceNumber();

    digestGet(0, digestTypeId, digest => {
      if(!this.mounted || (sn !== this.sequenceNumber)) {
        return;
      }

      const {digestType = {}} = digest;
      const sendOnceAt = digestType.reviewSendOnceAt;
      const sendOnceHours = sendOnceAt ? Math.ceil(moment.duration(moment(sendOnceAt).diff(moment())).asHours()) : defaultSendOnceHours;

      this.setState({
        sendTime: getNextDigestUTCDateTime(digest),
        sendOnceHours
      }, () => {
        if(this.onceInputRef && digestType.reviewFrequency === 'once') {
          this.onceInputRef.select();
        }
      });
    });
  };

  handleSetReviewSchedule = (digestType, key, value, actionMessageType) => {
    const currentValue = digestType[key];

    if(value === currentValue) {
      return;
    }

    const digestTypeOptions = {
      id: digestType.id,
      [key]: value
    };

    if(key === 'reviewSendOnceAt') {
      digestTypeOptions.reviewFrequency = 'once';
    }
    else if(key === 'reviewFrequency' && value === 'once' && !digestType.reviewSendOnceAt) {
      digestTypeOptions.reviewSendOnceAt = moment().add(defaultSendOnceHours, 'h').toISOString();
    }

    this.updateDigestType(digestTypeOptions, updated => {
      if(updated) {
        this.setState({
          actionMessageType
        }, () => this.refreshDigestSendTime(updated.id));
      }
    });
  };

  handleSetReviewFrequency = (digestType, frequency) => this.handleSetReviewSchedule(
    digestType, 'reviewFrequency', frequency, CompanySettingsDigest.reviewActionTypes.UPDATED_FREQUENCY
  );

  handleSetReviewDay = (digestType, day) => this.handleSetReviewSchedule(
    digestType, 'reviewDay', day, CompanySettingsDigest.reviewActionTypes.UPDATED_DAY_OFFSET
  );

  handleSetReviewHour = (digestType, hour) => this.handleSetReviewSchedule(
    digestType, 'reviewHour', hour, CompanySettingsDigest.reviewActionTypes.UPDATED_HOUR_OFFSET
  );

  handleSetReviewItemsPerRival = (digestType, itemsPerRival) => {
    const currentItemsPerRival = digestType.reviewItemsPerRival ?? 1;

    if(itemsPerRival < 0 || itemsPerRival > 10 || itemsPerRival === currentItemsPerRival) {
      return;
    }

    // DEBUG
    console.log('CompanySettingsDigest.handleSetReviewItemsPerRival: items per rival: %o', itemsPerRival);

    const digestTypeOptions = {
      id: digestType.id,
      reviewItemsPerRival: itemsPerRival
    };

    this.updateDigestType(digestTypeOptions, updated => {
      if(updated) {
        this.setState({
          actionMessageType: CompanySettingsDigest.reviewActionTypes.UPDATED_ITEMS_PER_RIVAL
        }, () => {
          // DEBUG
          console.log('CompanySettingsDigest.handleSetReviewItemsPerRival: updated items per rival: %o', this.state.actionMessageType);
        });
      }
    });
  };

  handleDismissFlashMessageClick = () => {
    this.setState({
      actionMessageType: CompanySettingsDigest.reviewActionTypes.NONE
    });
  };

  getDigestName = () => {
    const {selectedDigestType} = this.state;
    const defaultName = 'Intel Digest';
    const {utils: {isDigestMultiplesEnabled}} = this.context;

    if(isDigestMultiplesEnabled() && selectedDigestType?.name) {
      return `${capitalize(selectedDigestType.name)} ${defaultName}`;
    }

    return defaultName;
  };

  renderFlashMessageRegion = digestType => {
    const {actionMessageType} = this.state;
    const intelDigestName = this.getDigestName();

    if(!actionMessageType) {
      return;
    }

    let flashMessage;

    switch(actionMessageType) {
      case CompanySettingsDigest.reviewActionTypes.UPDATED_ROLE:
        const visibilityGroupsSelected = Array.isArray(digestType.reviewRole);
        const currentReviewRole = digestType.reviewRole || 'consumer';
        const activeRoleLabel = visibilityGroupsSelected
          ? 'selected visibility groups'
          : ((currentReviewRole === 'admin') ? 'admins only' : ((currentReviewRole === 'curator') ? 'curators & admins' : 'all users'));

        flashMessage = (
          <span>{`The ${intelDigestName} is now enabled for`} <strong>{activeRoleLabel}</strong>.</span>
        );

        break;
      case CompanySettingsDigest.reviewActionTypes.UPDATED_FREQUENCY:
      case CompanySettingsDigest.reviewActionTypes.UPDATED_DAY_OFFSET:
      case CompanySettingsDigest.reviewActionTypes.UPDATED_HOUR_OFFSET:
        const currentReviewFrequency = digestType.reviewFrequency;
        const activeFrequencyLabel = (currentReviewFrequency === 'biweekly') ? 'bi-weekly' : currentReviewFrequency;
        const currentDayLabel = capitalize(digestType.reviewDay);
        const currentHourLabel = digestType.reviewHour;
        let maybeDayLabel = '';

        if(activeFrequencyLabel === 'never') {
          flashMessage = (
            <span>
              Scheduled sending disabled, hit <strong>Send Now</strong> in Digest Editor when ready to send.
            </span>
          );
        }
        else if(activeFrequencyLabel === 'once') {
          const sendOnceAt = moment(digestType.reviewSendOnceAt);

          flashMessage = (
            <span>
              The {`${intelDigestName}`} will be sent <strong>once</strong>, at
              <strong> {`${sendOnceAt.format('LLLL')} ${Intl.DateTimeFormat().resolvedOptions().timeZone}`}</strong>.
            </span>
          );
        }
        else {
          if(activeFrequencyLabel === 'monthly') {
            maybeDayLabel = 'on the first day of the month, ';
          }
          else if(activeFrequencyLabel !== 'daily') {
            maybeDayLabel = (<span>on <strong>{`${currentDayLabel}s`}</strong> </span>);
          }

          flashMessage = (
            <span>
              The {`${intelDigestName}`} will be sent on a <strong>{activeFrequencyLabel}</strong> basis, {maybeDayLabel}
              at <strong>{`${currentHourLabel}:00 UTC`}</strong>.
            </span>
          );
        }

        break;
      case CompanySettingsDigest.reviewActionTypes.UPDATED_ITEMS_PER_RIVAL:
        const itemsPerRival = digestType.reviewItemsPerRival ?? 1;

        flashMessage = (itemsPerRival ?
          (<span>The {`${intelDigestName}`} will now include up to <strong>
            {itemsPerRival} {pluralize('article', itemsPerRival)}</strong> per company.</span>) :
          <span>Automatic inclusion of articles in the {`${intelDigestName}`} has been disabled.</span>
        );

        break;
      default:
        return;
    }

    return (
      <FlashMessage
        message={flashMessage}
        onDismissClick={this.handleDismissFlashMessageClick} />
    );
  };

  handleVisibilityGroupSelected = (ids, selected, {id, reviewRole = []}) => {
    if(!id) {
      return;
    }

    const digestTypeOptions = {
      id
    };

    if(selected) {
      digestTypeOptions.reviewRole = [...new Set((reviewRole || []).concat(ids))];
    }
    else {
      digestTypeOptions.reviewRole = reviewRole.filter(vgId => !ids.includes(vgId));
    }

    this.updateDigestType(digestTypeOptions);
  };

  renderReviewOptions = digestType => {
    const {utils: {isDigestMultiplesEnabled}} = this.context;
    const {visibilityGroups} = this.state;
    const digestMultiplesEnabled = isDigestMultiplesEnabled();
    let selectedGroups;
    let isVisibilityGroupsSelected = false;

    if(digestMultiplesEnabled && Array.isArray(digestType?.reviewRole)) {
      isVisibilityGroupsSelected = true;
      selectedGroups = digestType?.reviewRole;
    }

    const reviewRoleOptions = [
      {value: 'admin', label: 'Admins'},
      {value: 'curator', label: 'Admins & Curators'},
      {value: 'consumer', label: 'All users'}
    ];

    if(digestMultiplesEnabled) {
      reviewRoleOptions.splice(2, 0, {value: 'visibilityGroups', label: 'Admins, Curators & Visibility Groups'});
    }

    const currentReviewRole = isVisibilityGroupsSelected ? 'visibilityGroups' : (digestType?.reviewRole || 'consumer');
    const options = (
      <>
        <RadioCheckboxList
          options={reviewRoleOptions}
          selectedValue={currentReviewRole}
          onOptionClick={role => this.handleToggleReviewRole(digestType, role)}
          keyPrefix="review-role" />
        {isVisibilityGroupsSelected
          ? <DigestVisibilityGroups
              visibilityGroups={visibilityGroups}
              selectedGroups={selectedGroups}
              digestType={digestType}
              onGroupsChanged={this.handleVisibilityGroupSelected} />
          : null
        }
      </>
    );

    return options;
  };

  resetToDefaults = () => {
    const {selectedDigestType} = this.state;
    const {id} = selectedDigestType || {};

    if(!id) {
      return;
    }

    const digestTypeOptions = {
      id,
      reviewFrequency: defaultFrequency,
      reviewDay: defaultDay,
      reviewHour: defaultHour,
      reviewSendOnceAt: null
    };

    this.updateDigestType(digestTypeOptions, updated => {
      if(updated) {
        this.setState({
          actionMessageType: CompanySettingsDigest.reviewActionTypes.UPDATED_FREQUENCY,
          sendOnceHours: defaultSendOnceHours
        }, () => this.refreshDigestSendTime(updated.id));
      }
    });
  };

  handleResetToDefaults = () => {
    const {utils: {dialog} = {}} = this.context;

    dialog.confirm({
      message: 'Do you want to reset this Digest Schedule to the default schedule?',
      okCallback: this.resetToDefaults,
      buttonOk: 'Reset to Defaults'
    });
  };

  handleSetSendOnceAtClick = (event, digestType) => {
    if(event) {
      event.preventDefault();
    }

    const {sendOnceHours} = this.state;
    const sendOnceAt = moment().add(sendOnceHours, 'h').toISOString();

    this.handleSetReviewSchedule(
      digestType, 'reviewSendOnceAt', sendOnceAt, CompanySettingsDigest.reviewActionTypes.UPDATED_FREQUENCY
    );
  };

  handleSendOnceHoursEdit = event => {
    const {value} = event.target;
    const sendOnceHours = value.match(/[0-9]*/) || '';

    this.setState({sendOnceHours});
  };

  setOnceInputRef = el => {
    el && el.select();
    this.onceInputRef = el;
  };

  handleDigestSelect = digestTypeId => {
    const {digestTypes} = this.state;
    const selectedDigestType = digestTypes.find(dt => dt.id === digestTypeId);

    if(!selectedDigestType) {
      return;
    }

    this.setState({selectedDigestType, actionMessageType: CompanySettingsDigest.reviewActionTypes.NONE});
  };

  handleAddDigest = name => {
    const {api: {digestTypeCreate}} = this.context;

    return new Promise((resolve, reject) => {
      digestTypeCreate({name}, created => {
        if(created) {
          const {digestTypes} = this.state;
          const updatedTypes = [...digestTypes].concat(created);

          return this.setState({digestTypes: updatedTypes}, () => resolve(this.getDigestTypesSorted(updatedTypes)));
        }

        reject({message: 'Creating the new digest name failed. Please try again.'});
      });
    });
  };

  handleUpdateDigestName = (id, name) => {
    return new Promise((resolve, reject) => {
      this.updateDigestType({id, name}, updated => {
        if(updated) {
          const {digestTypes} = this.state;
          const updatedTypes = [...digestTypes].map(dt => ((dt.id === id) ? {...updated} : dt));

          return this.setState({digestTypes: updatedTypes}, () => resolve(this.getDigestTypesSorted(updatedTypes)));
        }

        reject({message: 'Updating the digest name failed. Please try again.'});
      });
    });
  };

  handleDeleteDigest = id => {
    const {api: {digestTypeDelete}} = this.context;

    return new Promise((resolve, reject) => {
      digestTypeDelete({id}, success => {
        if(success) {
          const {digestTypes} = this.state;
          const updatedTypes = [...digestTypes].filter(dt => dt.id !== id);

          return this.setState({digestTypes: updatedTypes}, () => resolve(this.getDigestTypesSorted(updatedTypes)));
        }

        reject({message: 'Deleting the digest failed. Please try again.'});
      });
    });
  };

  handleChangeDigestDefault = id => {
    return new Promise((resolve, reject) => {
      this.updateDigestType({id, default: true}, defaultDigest => {
        if(defaultDigest) {
          const {digestTypes} = this.state;
          const updatedTypes = [...digestTypes].map(dt => ((dt.id === id) ? {...defaultDigest} : {...dt, default: false}));

          return this.setState({
            digestTypes: updatedTypes
          }, () => resolve(this.getDigestTypesSorted(updatedTypes)));
        }

        reject({message: 'Updating the digest default failed. Please try again.'});
      });
    });
  };

  renderManageDigestsModal = () => {
    const {utils: {dialog}} = this.context;
    const {digestTypes} = this.state;
    const sortedDigestTypes = this.getDigestTypesSorted(digestTypes);

    const dialogBodyContent = (
      <ListItemsManage
        modalId={digestTypeManageDialogId}
        title="Manage Digests"
        createButton="Create New Digest"
        placeholder="New digest name"
        listItems={sortedDigestTypes}
        infoContent={(<div className="list-manage-info-content">
          <Icon
            icon="star"
            width="18"
            height="18"
            className="visibility-group_icon visibility-group_icon--default" />
          Your default digest.
        </div>)}
        onAdd={this.handleAddDigest}
        onUpdateName={this.handleUpdateDigestName}
        onDelete={this.handleDeleteDigest}
        onChangedDefault={this.handleChangeDigestDefault} />
    );

    dialog.create({
      id: digestTypeManageDialogId,
      content: dialogBodyContent,
      _widerMode: true
    });
  };

  getDigestTypesSorted = digestTypes => [...(digestTypes || [])]
    .sort((dt1, dt2) => (dt1.name || '').localeCompare(dt2.name || ''));

  renderMultiDigestSelector = selectedDigestType => {
    const {utils: {isDigestMultiplesEnabled}} = this.context;

    if(!isDigestMultiplesEnabled()) {
      return null;
    }

    const {digestTypes = []} = this.state;

    if(!digestTypes || !digestTypes.length) {
      return null;
    }

    const dropDownValues = [];

    this.getDigestTypesSorted(digestTypes).forEach(({id, name}, index) => {
      dropDownValues.push([id, name, false, '', {dataTestId: `drop-down-option-${index}`}]);
    });

    return (
      <div className="settings-digest_multi-options" data-testid="company-settings-digest-multi">
        <div className="title-and-dropdown">
          <h4><strong>Digest:</strong></h4>
          {digestTypes.length > 1
            ? (
              <DropdownMenu
                id="multiple-digests-selector"
                dataTrackingId="digest-settings-multiple-digests-dropdown"
                justification="left"
                values={dropDownValues}
                selectedValue={selectedDigestType?.id ?? ''}
                selectCallback={this.handleDigestSelect} />
            )
            : (
              <h4><strong>{digestTypes[0].name}</strong></h4>
            )
          }

        </div>
        <button
          className="button button--xsmall button--alt visibility-group-header--button"
          data-tracking-id="mange-digests-button"
          onClick={this.renderManageDigestsModal}>Manage</button>
      </div>
    );
  };

  renderFrequencyOptions = digestType => {
    const {sendTime} = this.state;
    const currentReviewFrequency = digestType?.reviewFrequency || defaultFrequency;
    const currentReviewDay = digestType?.reviewDay || defaultDay;
    const currentReviewHour = digestType?.reviewHour ?? defaultHour;
    const hideDayOptions = currentReviewFrequency === 'monthly' ||
      currentReviewFrequency === 'daily' ||
      currentReviewFrequency === 'once' ||
      currentReviewFrequency === 'never';
    const hideHourOptions = currentReviewFrequency === 'once' ||
      currentReviewFrequency === 'never';
    let hourInputRegion = null;

    if(currentReviewFrequency === 'once') {
      const {sendOnceHours} = this.state;

      hourInputRegion = (<form className="hours-input" onSubmit={e => this.handleSetSendOnceAtClick(e, digestType)}>
        <h6>Hours from Now</h6>
        <div>
          <div className="digest-send-once-group">
            <input
              ref={this.setOnceInputRef}
              type="text"
              className="form-control"
              autoFocus={true}
              value={sendOnceHours}
              onChange={this.handleSendOnceHoursEdit} />
            <input className="faux-form_submit" type="submit" />
          </div>
          <div className="button" onClick={e => this.handleSetSendOnceAtClick(e, digestType)}>
            Save
          </div>
        </div>
      </form>);
    }

    return (
      <div style={{margin: 0}}>
        <div className="ui-dropdown-panel ui-dropdown-panel--left digest-schedule u-pt-xxs" data-testid="company-settings-digest-frequency">
          <div data-testid="digest-schedule_frequency">
            <h6>Frequency</h6>
            <Dropdown
              label=""
              displayLabel="Select..."
              options={reviewFrequencyOptions}
              selectedValue={currentReviewFrequency}
              keyPrefix="group"
              className="btn secondary"
              containerClass="ui-dropdown--left"
              alignMenuLeft={true}
              onOptionClick={items => this.handleSetReviewFrequency(digestType, items)} />
          </div>
          {!hideDayOptions
            ? <div>
              <h6>Day</h6>
              <Dropdown
                label=""
                displayLabel="Select..."
                options={reviewDayOptions}
                selectedValue={currentReviewDay}
                keyPrefix="group"
                className="btn secondary"
                containerClass="ui-dropdown--left"
                alignMenuLeft={true}
                onOptionClick={items => this.handleSetReviewDay(digestType, items)} />
            </div>
            : null}
          {!hideHourOptions
            ? <div>
              <h6>Hour</h6>
              <Dropdown
                label=""
                displayLabel="Select..."
                options={reviewHourOptions}
                selectedValue={currentReviewHour}
                keyPrefix="group"
                className="btn secondary"
                containerClass="ui-dropdown--left"
                alignMenuLeft={true}
                onOptionClick={items => this.handleSetReviewHour(digestType, items)} />
            </div>
            : null}
          {hourInputRegion}
          <div className="digest-schedule-reset" title="Reset to defaults" onClick={this.handleResetToDefaults}>
            <Icon icon="refresh" />
          </div>
        </div>
        {sendTime
          ? <div className="digest-schedule-time">
            <span className="head">Next scheduled send:</span>
            <span className="time">
              <time dateTime={sendTime.toDate()}>{`${sendTime.format('LLLL')} ${Intl.DateTimeFormat().resolvedOptions().timeZone}`}</time>
            </span>
          </div>
          : <div className="digest-schedule-time">
            <span className="head">Scheduled sending disabled, hit <strong>Send Now</strong> in Digest Editor when ready to send.</span>
          </div>
        }
      </div>
    );
  };

  renderItemOptions = digestType => {
    const itemsPerRival = digestType?.reviewItemsPerRival ?? 1;
    const frequencyOptions =
      [{value: 0, label: 'none'}].concat([...Array(10).keys()].map(n => ({value: n + 1, label: `${n + 1} article${!n ? '' : 's'}`})));

    return (
      <div className="ui-dropdown-panel ui-dropdown-panel--left u-pt-xxs u-mb-m" data-testid="company-settings-digest-articles">
        <Dropdown
          label=""
          displayLabel="Select..."
          options={frequencyOptions}
          selectedValue={itemsPerRival}
          keyPrefix="group"
          className="btn secondary"
          containerClass="ui-dropdown--left"
          alignMenuLeft={true}
          onOptionClick={items => this.handleSetReviewItemsPerRival(digestType, items)} />
      </div>
    );
  };

  render() {
    const {utils: {company}} = this.context;
    const {selectedDigestType: stateDigestType} = this.state;
    const selectedDigestType = stateDigestType ?? company?.defaultDigestType;

    return (
      <div className="company-settings company-settings-review">
        <h3 className="u-m0">Intel Digest Email Settings</h3>
        <div className="help-block u-mb-m">
          Configure the <Link to="/digest"><strong>Intel Digest</strong></Link>&apos;s audience, delivery schedule and status.
          <br />
          <br />
          Users are able to disable the <strong>Intel Digest</strong> on their individual accounts.
        </div>
        {this.renderMultiDigestSelector(selectedDigestType)}
        {this.renderFlashMessageRegion(selectedDigestType)}
        <h4 className="u-pt-m"><strong>Digest Status</strong></h4>
        <div className="help-block u-mb-xs">
          Limit the <strong>Intel Digest</strong> feature to specific user roles. This setting affects both the scheduled email and
          access to the feature within Klue.<br />
          <br />
          The following user roles will have this feature <strong>enabled</strong> as part of their Klue experience:<br />
        </div>
        <div className="settings-review_review-options u-mb-m" data-testid="company-settings-digest-role">
          {this.renderReviewOptions(selectedDigestType)}
        </div>
        <h4 className="u-pt-m"><strong>Digest Schedule</strong></h4>
        <div className="help-block u-mb-xs">
          Set the default <strong>Intel Digest</strong> delivery frequency and timing.
          Scheduling is always based on <a href="https://www.timeanddate.com/worldclock/timezone/utc">Universal Time</a> to
          avoid time-zone dependent behaviors.<br />
          <br />
          While email will be <strong>sent</strong> based on this schedule, <strong>receiving</strong> is
          subject to delivery delays that can be up to a few hours.<br />
        </div>
        <div className="settings-review_frequency-options u-mb-m">
          {this.renderFrequencyOptions(selectedDigestType)}
        </div>
        <h4 className="u-pt-m"><strong>Digest Articles</strong></h4>
        <div className="help-block u-mb-xs">
          Set the maximum number of articles to be automatically included per company in your <strong>Intel Digest</strong>.<br />
          <br />
          Select <strong>None</strong> to disable automatic inclusion of articles.<br />
        </div>
        <div className="settings-review_frequency-options u-mb-m">
          {this.renderItemOptions(selectedDigestType)}
        </div>
      </div>
    );
  }

}

export default CompanySettingsDigest;
